export default __webpack_public_path__ + "static/background-f03f0ac36b842e9fee93ee07169fcb2b.mp4";